var React = require('react');

function Crypto (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"60","cy":"60","r":"60","fill":"white","key":0}),React.createElement("path",{"d":"M69.8333 77.0625H66.3819L62.25 73.2708V71.3264L66.5278 67.243V60.7778L72.1181 57.1319L78.4861 61.9444L69.8333 77.0625ZM55.5417 66.8542L56.1736 60.7778L54.0833 55.3333H66.4306L64.3889 60.7778L64.9722 66.8542H60.2083H55.5417ZM58.3611 73.2708L54.2292 77.1111H50.7292L42.0278 61.9444L48.4444 57.1806L54.0833 60.7778V67.243L58.3611 71.3264V73.2708ZM50.6806 44.1042H69.7847L72.0694 53.8264H48.4444L50.6806 44.1042ZM60.2569 32L36 46V74L60.2569 88L84.5139 74V46L60.2569 32Z","fill":"#03316C","key":1})]);
}

Crypto.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = Crypto;

Crypto.default = Crypto;
